import { AppRoutes } from '@constants/app-routes'
import ZigzagImage from '@public/images/zigzaglong.svg'
import { Link } from '@ui/links/Link'

import { OrangeHalfHexagonRight, OrangeHalfHexagonLeft } from './styles'

export const config = {
  title: 'Transparent software development process',
  subtitle: (
    <>
      We focus on building impeccable internal processes and gathering high-end
      dedicated professionals to provide you with the ultimate{' '}
      <Link href={AppRoutes.portfolio}>software solutions</Link>.
    </>
  ),

  firstConfig: [
    {
      id: 1,
      imagePath: '/images/one.webp',
      alt: 'Explore',
      title: 'Explore',
      subtitle:
        'We’ll immerse ourselves in your business to understand your needs and goals, and craft a custom solution that meets them.',
      imageTitle: 'Explore',
    },
    {
      id: 3,
      imagePath: '/images/three.webp',
      alt: 'Discover',
      title: 'Discover',
      subtitle:
        'We’ll scrutinise your project’s scope, target audience, and competition to create a comprehensive blueprint that guides our development.',
      imageTitle: 'Discover',
    },
    {
      id: 5,
      imagePath: '/images/five.webp',
      alt: 'Develop',
      title: 'Develop',
      subtitle:
        'Our experts will use Agile methodology, cutting-edge tools, and conduct regular QA tests, demos, and third-party audits.',
      imageTitle: 'Develop',
    },
    {
      id: 7,
      imagePath: '/images/seven.webp',
      alt: 'Support',
      title: 'Support',
      subtitle:
        'Our post-closing support includes 24/7/365 maintenance and assistance, ensuring your solution runs smoothly, now and in the future.',
      imageTitle: 'Support',
    },
  ],

  secondConfig: [
    {
      id: 2,
      imagePath: '/images/two.webp',
      alt: 'Initiate',
      title: 'Initiate',
      subtitle:
        'Our dedicated team will manage your project, keeping everyone aligned, deadlines met, and budgets respected.',
      imageTitle: 'Initiate',
    },
    {
      id: 4,
      imagePath: '/images/four.webp',
      alt: 'Plan',
      title: 'Plan',
      subtitle:
        'We’ll create a master plan with milestones and timelines for infrastructure design, coding, testing, and deployment.',
      imageTitle: 'Plan',
    },
    {
      id: 6,
      imagePath: '/images/six.webp',
      alt: 'Close',
      title: 'Close',
      subtitle:
        'We’ll deliver the final code, documentation, and user guide, so you can maintain and improve your solution going forward.',
      imageTitle: 'Close',
    },
  ],

  image: <ZigzagImage />,
  coupleHexagons: <OrangeHalfHexagonRight />,
  hexagon: <OrangeHalfHexagonLeft />,
  padding: '7%',
}
